"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mapContainer = _interopRequireDefault(require("./components/map-container"));
var _utils = require("./components/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var defaultManualCenter = {
  lat: 59.8984328,
  lng: 10.5370038
};
var MODE_INIT = 1;
var MODE_ASK = 2;
var MODE_GEOLOC = 3;
var MODE_MANUAL = 4;
var MODE_FAILED = -1;
var Loading = function Loading() {
  return _react.default.createElement("div", {
    className: "loading-spinner"
  });
};
var missing = function missing(str) {
  return !str || str.length === 0;
};
var ProductMap = function (_React$Component) {
  function ProductMap(props) {
    var _this;
    _classCallCheck(this, ProductMap);
    _this = _callSuper(this, ProductMap, [props]);
    _this.askPermission = _this.askPermission.bind(_this);
    _this.handleLocation = _this.handleLocation.bind(_this);
    _this.getStores = _this.getStores.bind(_this);
    _this.errorHandler = _this.errorHandler.bind(_this);
    _this.handleStoreResults = _this.handleStoreResults.bind(_this);
    _this.mapMoved = _this.mapMoved.bind(_this);
    _this.state = {
      location: null,
      stores: [],
      mode: MODE_INIT,
      loading: false
    };
    _this.previousLocation = null;
    _this.previousZoom = null;
    return _this;
  }
  _inherits(ProductMap, _React$Component);
  return _createClass(ProductMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (missing(this.props.sku) || missing(this.props.apikey)) {
        this.setState({
          mode: MODE_FAILED
        });
        return;
      }
      if (typeof navigator.permissions === "undefined" || typeof navigator.permissions.query === "undefined") {
        this.setState({
          mode: MODE_ASK
        });
      } else {
        navigator.permissions.query({
          name: 'geolocation'
        }).then(function (res) {
          if (res.state === "denied") {
            _this2.setState({
              mode: MODE_MANUAL,
              location: defaultManualCenter
            });
          } else if (res.state === "prompt") {
            _this2.setState({
              mode: MODE_ASK
            });
          } else if (res.state === "granted") {
            _this2.askPermission();
          }
        });
      }
    }
  }, {
    key: "askPermission",
    value: function askPermission() {
      navigator.geolocation.getCurrentPosition(this.handleLocation, this.errorHandler);
    }
  }, {
    key: "getStores",
    value: function getStores(_ref, dist) {
      var lat = _ref.lat,
        lng = _ref.lng;
      this.setState({
        loading: true
      });
      var params = {
        lat: lat,
        lng: lng,
        dist: dist,
        sku: this.props.sku
      };
      fetch(this.props.storeServiceUrl + '?' + new URLSearchParams(Object.entries(params))).then(function (e) {
        return e.json();
      }).then(this.handleStoreResults);
    }
  }, {
    key: "handleLocation",
    value: function handleLocation(loc) {
      this.setState({
        mode: MODE_GEOLOC,
        location: {
          lat: loc.coords.latitude,
          lng: loc.coords.longitude
        }
      });
    }
  }, {
    key: "handleStoreResults",
    value: function handleStoreResults(resp) {
      var newIds = resp.hits.map(function (s) {
        return s.uniqueId;
      });
      var oldIds = this.state.stores.map(function (s) {
        return s.uniqueId;
      });
      var existingStores = this.state.stores.filter(function (e) {
        return newIds.includes(e.uniqueId);
      });
      var newStores = resp.hits.filter(function (e) {
        return !oldIds.includes(e.uniqueId);
      });
      var finalObj = [].concat(_toConsumableArray(existingStores), _toConsumableArray(newStores.map(function (h) {
        return _objectSpread(_objectSpread({}, h), {}, {
          location: {
            lat: h.location.lat,
            lng: h.location.lon
          }
        });
      })));
      this.setState({
        loading: false,
        stores: finalObj
      });
    }
  }, {
    key: "errorHandler",
    value: function errorHandler() {
      this.setState({
        mode: MODE_MANUAL,
        location: defaultManualCenter
      });
    }
  }, {
    key: "mapMoved",
    value: function mapMoved(mapProps, map) {
      var _this3 = this;
      if (typeof map.getBounds() === "undefined") {
        setTimeout(function () {
          return _this3.mapMoved(mapProps, map);
        }, 500);
        return;
      }
      var center = map.getCenter().toJSON();
      var bounds = map.getBounds().toJSON();
      var zoom = map.getZoom();
      var distanceNeeded = (0, _utils.calculateMapCoverage)(bounds);
      if (this.previousLocation != null && this.previousZoom != null) {
        var deltaLat = Math.abs(this.previousLocation.lat - center.lat);
        var deltaLng = Math.abs(this.previousLocation.lng - center.lng);
        var deltaZoom = Math.abs(this.previousZoom - zoom);
        if (deltaLat > 0.01 || deltaLng > 0.01 || deltaZoom > 0) {
          this.getStores(center, distanceNeeded);
        }
      } else {
        this.getStores(center, distanceNeeded);
      }
      this.previousLocation = center;
      this.previousZoom = zoom;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.mode === MODE_FAILED) {
        return null;
      }
      var heading = missing(this.props.heading) ? 'Utsalgssteder' : this.props.heading;
      if (this.state.mode === MODE_ASK) {
        return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
          className: "title--part"
        }, _react.default.createElement("h2", {
          className: "t-heading t-text--center"
        }, heading), _react.default.createElement("p", {
          className: "t-preface article-preface"
        }, "Godta foresp\xF8rsel om lokasjon for \xE5 finne dette produktet i en butikk n\xE6r deg!")), _react.default.createElement("div", {
          className: "product-map-container instructions"
        }, _react.default.createElement("button", {
          className: "a-btn",
          onClick: this.askPermission
        }, "Finn en butikk n\xE6r meg!")));
      }
      if (this.state.mode === MODE_GEOLOC || this.state.mode === MODE_MANUAL) {
        return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("h2", {
          className: "t-heading t-text--center"
        }, heading), _react.default.createElement("div", {
          className: "product-map-container"
        }, this.state.loading && _react.default.createElement(Loading, null), _react.default.createElement(_mapContainer.default, {
          apiKey: this.props.apikey,
          initialPosition: this.state.location,
          onChange: this.mapMoved,
          stores: this.state.stores
        })));
      }
      return _react.default.createElement("p", null, "Laster...");
    }
  }]);
}(_react.default.Component);
ProductMap.propTypes = {
  sku: _propTypes.default.string.isRequired,
  storeServiceUrl: _propTypes.default.string.isRequired,
  apikey: _propTypes.default.string.isRequired,
  heading: _propTypes.default.string
};
var Component = exports.Component = ProductMap;
var _default = exports.default = {
  Component: Component
};